import { db } from '../firebase';
import { doc, getDoc, setDoc, updateDoc, increment } from 'firebase/firestore';

const SCAN_LIMIT = 10;
const PREMIUM_DOMAIN = 'anivance.io';

// Premium 白名單 - 特定 email 可享有 Premium 權限
const PREMIUM_WHITELIST = [
  'jia990127@gmail.com',
  'renhao.ee09@nycu.edu.tw',
  'g199500@gmail.com',
  'weiweiyang0221@gmail.com',
  'chloehaoyulo@gmail.com',
];

export const userService = {
  // 檢查用戶是否為 Premium
  isPremiumUser: (email) => {
    if (!email) return false;
    // 檢查是否在白名單中，或是否為 Premium 網域
    return PREMIUM_WHITELIST.includes(email.toLowerCase()) ||
           email.endsWith(`@${PREMIUM_DOMAIN}`);
  },

  // 獲取用戶資料
  getUserData: async (userId) => {
    try {
      const userRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        return userDoc.data();
      } else {
        // 如果用戶不存在，創建新用戶
        const newUserData = {
          scanCount: 0,
          createdAt: new Date(),
          lastScanDate: null
        };
        await setDoc(userRef, newUserData);
        return newUserData;
      }
    } catch (error) {
      console.error('獲取用戶資料失敗:', error);
      throw error;
    }
  },

  // 檢查是否可以掃描
  canScan: async (userId, email) => {
    if (userService.isPremiumUser(email)) {
      return { allowed: true, reason: 'premium' };
    }

    const userData = await userService.getUserData(userId);
    
    if (userData.scanCount < SCAN_LIMIT) {
      return { allowed: true, remaining: SCAN_LIMIT - userData.scanCount };
    } else {
      return { allowed: false, reason: 'limit_reached' };
    }
  },

  // 增加掃描次數
  incrementScanCount: async (userId) => {
    try {
      // 先確保用戶文檔存在
      await userService.getUserData(userId);
      
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        scanCount: increment(1),
        lastScanDate: new Date()
      });
    } catch (error) {
      console.error('更新掃描次數失敗:', error);
      throw error;
    }
  },

  // 獲取剩餘掃描次數
  getRemainingScans: async (userId, email) => {
    if (userService.isPremiumUser(email)) {
      return { unlimited: true };
    }

    const userData = await userService.getUserData(userId);
    const remaining = Math.max(0, SCAN_LIMIT - userData.scanCount);
    
    return {
      unlimited: false,
      remaining,
      total: SCAN_LIMIT,
      used: userData.scanCount
    };
  }
};